import { render, staticRenderFns } from "./RowMinusHeader.vue?vue&type=template&id=2454d5f8"
import script from "./RowMinusHeader.vue?vue&type=script&lang=js"
export * from "./RowMinusHeader.vue?vue&type=script&lang=js"
import style0 from "./RowMinusHeader.vue?vue&type=style&index=0&id=2454d5f8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports